// extracted by mini-css-extract-plugin
export default {"topSection":"Marketplace_topSection__oEnM4","topHeader":"Marketplace_topHeader__A7L1c","topSubHeader":"Marketplace_topSubHeader__0a-cF","wrapper":"Marketplace_wrapper__ds75O"};